export const bottomCTA = {
  head: "External data can be easy to discover and deploy",
};
